module.exports = __webpack_public_path__ + "static/media/straight-right.61f4fb53.svg";